import React from "react";
import { Button, Form, Input } from "antd";

import "./GetAliasForm.css";

export const GetAliasForm = ({ form, onFinish }) => {
  return (
    <div className="form-container">
      <div className="box">
        <h2 className="title">
          Ingrese el alias de su organización. Si aún no tiene uno, indique el
          nombre legal de su organización.
        </h2>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="alias"
            label="Alias"
            rules={[{ required: true, message: "Por favor, ingrese un alias" }]}
          >
            <Input placeholder="Ingrese un alias" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="float-right">
              Continuar
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
